export enum DeliveryIssueTypeInternational {
    EARLY_DELIVERY = 'Early Delivery',
    LATE_DELIVERY = 'Late Delivery',
    LOST_IN_TRANSIT = 'Lost in Transit',
    MISSING_BOX = 'Missing Box',
    DELIVERED_TO_WRONG_ADDRESS = 'Delivered to Wrong Address',
    DELIVERED_TO_WRONG_PORT = 'Delivered to Wrong Port (air or sea)',
    DELIVERED_BY_WRONG_CARRIER = 'Delivered by Wrong Carrier',
    ATELLICA_INVENTORY_MANAGER = 'Atellica Inventory Manager'
}
